// Auto-add / auto-remove a gift product when the cart total crosses the jewelry threshold.
// Mirrors the approach used in free-gift.js: sections in the request body, badge event dispatch,
// and a fetch interceptor that reads the response cart directly.

(function () {
  var SECTIONS = ['cart-drawer-section'];
  var _fetch = window.fetch;   // captured before any patch
  var giftOp  = false;         // true while we are making a gift add/remove call
  var syncing = false;

  // ─── Config ────────────────────────────────────────────────────────────────

  function getConfig() {
    var cfg = window.__cspGiftConfig;
    if (!cfg || !cfg.variantId || !cfg.jewelryCents) return null;
    return cfg;
  }

  function isGiftItem(item) {
    var cfg = getConfig();
    return cfg && (item.variant_id === cfg.variantId ||
      (item.properties && item.properties['_csp_gift'] === 'true'));
  }

  // ─── DOM helpers ───────────────────────────────────────────────────────────

  function applyDOMOnly(sections) {
    Object.keys(sections).forEach(function (id) {
      var html = sections[id];
      if (!html) return;
      var doc = (new DOMParser()).parseFromString(html, 'text/html');
      var newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
      var oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
      if (newInner && oldInner) oldInner.innerHTML = newInner.innerHTML;
    });
  }

  // Dispatch on the cart-items-component so CartItemsComponent skips it
  // (it ignores events where target === itself) while cart-icon.js and
  // header-actions.js still receive it via bubbling.
  function dispatchBadgeEvent(itemCount) {
    try {
      var evt = new CustomEvent('shopify:cart:lines-update', {
        bubbles: true,
        detail: { itemCount: itemCount }
      });
      evt.promise = Promise.resolve({ cart: { totalQuantity: itemCount }, detail: { itemCount: itemCount } });
      var component = document.querySelector('cart-items-component[data-section-id="cart-drawer-section"]');
      (component || document).dispatchEvent(evt);
    } catch (e) {}
  }

  function applySections(data) {
    if (!data || !data.sections) return;
    applyDOMOnly(data.sections);
    if (data.item_count !== undefined) {
      dispatchBadgeEvent(data.item_count);
    } else {
      // add.js response doesn't include item_count — fetch fresh cart for badge
      _fetch('/cart.js').then(function (r) { return r.json(); })
        .then(function (c) { dispatchBadgeEvent(c.item_count); })
        .catch(function () {});
    }
  }

  // ─── Cart mutations ────────────────────────────────────────────────────────

  function addGift(variantId) {
    giftOp = true;
    return _fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { '_csp_gift': 'true' } }],
        sections: SECTIONS
      })
    }).then(function (res) {
      giftOp = false;
      if (!res.ok) {
        return res.json().then(function (err) {
          console.error('[csp-gift] add failed', res.status, err);
        });
      }
      return res.json().then(applySections);
    }).catch(function (err) {
      giftOp = false;
      console.error('[csp-gift] add error', err);
    });
  }

  function removeGift(variantId) {
    var updates = {};
    updates[variantId] = 0;
    giftOp = true;
    return _fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: SECTIONS })
    }).then(function (res) {
      giftOp = false;
      if (!res.ok) {
        return res.json().then(function (err) {
          console.error('[csp-gift] remove failed', res.status, err);
        });
      }
      return res.json().then(applySections);
    }).catch(function (err) {
      giftOp = false;
      console.error('[csp-gift] remove error', err);
    });
  }

  function done() { syncing = false; }

  // ─── Sync logic ────────────────────────────────────────────────────────────

 function resolveGiftOp(cart) {
  var cfg = getConfig();
  if (!cfg) return null;
  var hasGift    = cart.items.some(isGiftItem);
  var shouldHave = cart.total_price >= cfg.jewelryCents;
  if (shouldHave && !hasGift) {
    return addGift(cfg.variantId);
  }
  return null;
}

  // Full sync: fetches current cart then decides.
  function syncGiftState() {
    if (syncing) return;
    syncing = true;
    _fetch('/cart.js').then(function (r) { return r.json(); })
      .then(resolveGiftOp)
      .then(done, function (e) { console.error('[csp-gift]', e); done(); });
  }

  // Fast sync: cart data already available from a response body.
  function syncFromCart(cart) {
    if (syncing) return;
    syncing = true;
    Promise.resolve(resolveGiftOp(cart))
      .then(done, function (e) { console.error('[csp-gift]', e); done(); });
  }

  // ─── Fetch interceptor ────────────────────────────────────────────────────

  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var url  = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    var isAdd    = !giftOp && /\/cart\/add(\.js)?/.test(url);
    var isChange = !giftOp && /\/cart\/(change|update)(\.js)?/.test(url);

    return _fetch.apply(window, args).then(function (res) {
      if (res.ok) {
        if (isAdd) {
          // add.js returns only added items — need a fresh cart fetch
          syncGiftState();
        } else if (isChange && !syncing) {
          // change/update.js returns the full cart — use it directly
          res.clone().json().then(syncFromCart).catch(syncGiftState);
        }
      }
      return res;
    });
  };

  // ─── Initialise ────────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', syncGiftState);
})();
